import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import './style.scss';
import LazyLoad from 'react-lazyload';

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  loop: true,
  adaptiveHeight: false,
  cssEase: 'linear',
  centerPadding: 50,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
  style: {
    height: '100%',
  },
};

function ListPlatForm() {
  const [platforms, setPlatForms] = useState([]);
  let sliderRef = React.createRef();
  const getPlatforms = () => {
    axios.get('/api/v1/platform/register_count/desc').then(({ data }) => {
      if (data.success) {
        setPlatForms([...data.payload]);
      }
    });
  };

  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };

  useEffect(() => {
    getPlatforms();
  }, []);

  return (
    <div className='widgets-post-carausel-1 mb-40'>
      <div className='container'>
        <div className='post-carausel-1 border-radius-10 bg-white'>
          <div className='row no-gutters'>
            <div className='col col-1-5 background6 editor-picked-left d-none d-lg-block'>
              <div className='editor-picked'>
                <h4>Nền tảng số</h4>
                <p className='font-medium color-grey mt-20 mb-30'>
                  Bộ công cụ chuyển đổi số các nghiệp vụ khác nhau dành cho
                  doanh nghiệp nhỏ và vừa. Các công cụ đều được đánh giá và gợi
                  ý bởi SMEdx
                </p>
                <a href='/nen-tang-so' className='read-more'>
                  Xem thêm
                </a>
                <div className='post-carausel-1-arrow'>
                  <button
                    type='button'
                    className='button-slick'
                    onClick={previous}
                  >
                    <i className='flaticon-left'></i>
                  </button>
                  <button type='button' className='button-slick' onClick={next}>
                    <i className='flaticon-right'></i>
                  </button>
                </div>
              </div>
            </div>
            <div className='col col-4-5 col-md-12'>
              <div className='post-carausel-1-items'>
                <Slider {...settings} ref={(c) => (sliderRef = c)}>
                  {platforms.length > 0 &&
                    platforms.map(
                      ({ name, thumbnail, slug, register_count }, index) => (
                        <div className='slider-single' key={index}>
                          <h6 className='post-title pr-5 pl-5 mb-10 text-limit-2-row'>
                            <a href={`/nen-tang-so/${slug}`}>{name}</a>
                          </h6>
                          <div
                            style={{
                              height: 170,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <a href={`/nen-tang-so/${slug}`}>
                              <img
                                width='126px'
                                className='border-radius-5'
                                src={thumbnail}
                                alt='post-slider'
                              />
                            </a>
                          </div>
                          <div className='entry-meta meta-1 font-small color-grey mt-10 pr-5 pl-5'>
                            <span className='hit-count'>
                              {register_count} lượt đăng kí
                            </span>
                          </div>
                        </div>
                      )
                    )}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListPlatForm;
